import {CanActivateChildFn, CanActivateFn} from '@angular/router';
import {map} from 'rxjs/operators';
import {inject} from '@angular/core';
import {AppLanguage, LanguageService} from '../../services/language.service';

function setLanguage(language: AppLanguage) {
    return () => inject(LanguageService).use(language).pipe(map(() => true));
}

export const germanLanguageGuard: CanActivateFn = setLanguage('de');
export const englishLanguageGuard: CanActivateFn & CanActivateChildFn = setLanguage('en');
